// @flow

type CloseOverlay = 'bravissimo/overlay/CLOSE_OVERLAY';
type OpenOverlay = 'bravissimo/overlay/OPEN_OVERLAY';
export const OPEN_OVERLAY: OpenOverlay = 'bravissimo/overlay/OPEN_OVERLAY';
export const CLOSE_OVERLAY: CloseOverlay = 'bravissimo/overlay/CLOSE_OVERLAY';
